import enUS from '../language/en-US.json';
import { getMyProfile, updateMyProfile } from './api';

const EAGLE_PREFERRED_LANGUAGE = 'eagle_preferred_language';

let translations = {
  'en-US': enUS,
};

let currentLanguage = (() => {
  try {
    return localStorage.getItem(EAGLE_PREFERRED_LANGUAGE) || 'pt-BR';
  } catch {
    return 'pt-BR';
  }
})();

const persistLanguage = (lang) => {
  try {
    localStorage.setItem(EAGLE_PREFERRED_LANGUAGE, lang);
  } catch (_) {}
};

export const loadTranslations = async () => {
  try {
    const ptBR = await import('../language/pt-BR.json');
    translations['pt-BR'] = ptBR.default;
  } catch (error) {
    console.error('Failed to load pt-BR translations:', error);
  }
};

export const loadLanguageFromBackend = async () => {
  try {
    const response = await getMyProfile();
    if (response.data && response.data.preferred_language) {
      currentLanguage = response.data.preferred_language;
      persistLanguage(currentLanguage);
    }
  } catch (error) {
    console.error('Failed to load language from backend:', error);
  }
};

export const setLanguage = async (lang, saveToBackend = true) => {
  currentLanguage = lang;
  persistLanguage(lang);
  if (saveToBackend) {
    try {
      await updateMyProfile({ preferred_language: lang });
    } catch (error) {
      console.error('Failed to save language to backend:', error);
    }
  }
};

export const getLanguage = () => {
  return currentLanguage;
};

export const translate = (key, params) => {
  const pathKeys = key.split('.');
  let value = translations[currentLanguage] || translations['en-US'];

  for (const k of pathKeys) {
    value = value?.[k];
    if (value === undefined) {
      return key;
    }
  }

  let result = value || key;
  if (typeof result !== 'string') {
    return result;
  }
  if (params && typeof params === 'object') {
    Object.keys(params).forEach((paramKey) => {
      result = result.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), String(params[paramKey]));
    });
  }
  return result;
};

loadTranslations();

